/*
  Automatically instantiates modules based on data-attrubiutes
  specifying module file-names.
*/

const modules = {
  imageGallery: require("/src/js/modules/imageGallery"),
  print: require("/src/js/modules/print"),
  userlogin: require("/src/js/modules/userlogin"),
};

const moduleElements = document.querySelectorAll("[data-module]");

for (var i = 0; i < moduleElements.length; i++) {
  const el = moduleElements[i];
  const name = el.getAttribute("data-module");
  const Module = modules[name].default;
  new Module(el);
}

/*
  Usage:
  ======

  html
  ----
  <button data-module="disappear">disappear!</button>

  js
  --
  // modules/disappear.js
  export default class Disappear {
    constructor(el) {
      el.style.display = none
    }
  }
*/
